import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import { TableSortLabel } from "@mui/material";

interface Props {
  tableHeadings: { [key: string]: string };
  rows: any[];
}

const ConfigAndMapDetailsTable = ({ tableHeadings, rows }: Props) => {
  const headCells = Object.entries(tableHeadings);

  return (
    <>
      <TableContainer className="receiptsTable" sx={{ my: 1, width: "50%" }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              {headCells.map(([_, value], index) => (
                <TableCell key={index} align="left">
                  <TableSortLabel>
                    {value && typeof value === "string" ? value : ""}
                  </TableSortLabel>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <React.Fragment key={row.cron_id}>
                <TableRow
                  sx={{
                    "& > *": {
                      borderBottom:
                        "1px solid rgba(224, 224, 224, 1) !important",
                    },
                  }}
                >
                  {headCells.map(([key], cellIndex) => (
                    <TableCell key={cellIndex} align="left">
                      {key === "metric" ? (
                        <>{row[key] ? row[key] : "N/A"}</>
                      ) : key === "derivation" ? (
                        <>{row[key] ? row[key] : "N/A"}</>
                      ) : (
                        "N/A"
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default ConfigAndMapDetailsTable;
